import script from "./Dashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./Dashboard.vue?vue&type=script&setup=true&lang=ts"
/* custom blocks */
import block0 from "./Dashboard.vue?vue&type=custom&index=0&blockType=styles&lang=postcss&scoped=true"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__